"use strict";

define('components/filter_bar/table_filter_bar',[
    'components/filter_bar',
    'components/filter_bar/storage/url_storage',
    'components/filter_bar/table/bulk_add_as_prospects_to',
    'components/filter_bar/table/bulk_assign_to',
    'components/filter_bar/table/bulk_create_portal_users',
    'components/filter_bar/table/bulk_data_room_invite',
    'components/filter_bar/table/bulk_download',
    'components/filter_bar/table/bulk_edit',
    'components/filter_bar/table/bulk_email',
    'components/filter_bar/table/bulk_investor_report',
    'components/filter_bar/table/bulk_portal_invite',
    'components/filter_bar/table/bulk_publish',
    'components/filter_bar/table/bulk_request_disregarded_entity_details',
    'components/filter_bar/table/bulk_send_electronic_delivery_consent',
    'components/filter_bar/table/bulk_set_investor_group',
    'components/filter_bar/table/bulk_set_payment_pref',
    'components/filter_bar/table/bulk_subscription_invite',
    'components/filter_bar/table/leads_action',
    'components/filter_bar/table/manage_views',
    'components/filter_bar/table/result_counts',
    'components/filter_bar/filters/tag_filters',
    'components/ajax',
    'components/table',
    'components/table_settings'
], function(
    filterBarComponent,
    urlStorageComponent,
    bulkAddAsProspectsToComponent,
    bulkAssignToComponent,
    bulkCreatePortalUsersComponent,
    bulkDataRoomInviteComponent,
    bulkDownloadComponent,
    bulkEditComponent,
    bulkEmailComponent,
    bulkInvestorReportComponent,
    bulkPortalInviteComponent,
    bulkPublishComponent,
    bulkRequestDisregardedEntityDetailsComponent,
    bulkSendElectronicDeliveryConsentComponent,
    bulkSetInvestorGroupComponent,
    bulkSetPaymentPrefComponent,
    bulkSubscriptionInviteComponent,
    leadsActionComponent,
    manageViewsComponent,
    resultCountsComponent,
    tagFiltersComponent,
    ajax,
    Table,
    TableSettings
) {
    var tableFilterBarComponent = {
        init: function(node) {
            var context = filterBarComponent.init(node);

            tableFilterBarComponent.initWithContext(context);
        },

        initWithContext: function(context) {
            urlStorageComponent.initWithContext(context);

            _initData(context);
            _initFilters(context);
            _initActions(context);

            resultCountsComponent.initWithContext(context);

            context.buttonbarNode.on('jsq:resultCountsClickedClearFilters', function(e, data) {
                _handleClickedClearFilters(context, data.url);
            });

            manageViewsComponent.initWithContext(context);

            _registerTableSortEvents(context);
            _updateDownloadURL(context);

            context.onStateSaved(function() {
                _fetchTableData(context);
            });
            window.addEventListener("jsq:prospectListRefresh", function() {
                _fetchTableData(context);
            });
        }
    };

    // This should be called before any of the other _init* functions.
    function _initData(context) {
        var buttonbarNode = context.buttonbarNode;

        var tableId = buttonbarNode.data('table-name');

        var tableContainer = $('#' + tableId);

        var tableInstance = new Table();
        tableInstance.init(tableContainer);

        var tableSettingsInstance = new TableSettings();

        var tableObjectType = null;
        if (tableId == "position_list") {
            tableObjectType = 9;
        } else if (tableId == "prospect_list") {
            tableObjectType = 5;
        } else if (tableId == "contact_list") {
            tableObjectType = 3;
        } else if (tableId == "account_list") {
            tableObjectType = 6;
        } else if (tableId == "event_log_list") {
            tableObjectType = 23;
        } else if (tableId == "inbound_leads_list") {
            tableObjectType = 27;
        }

        context.tableFilterBarData = {
            tableId: tableId,
            tableInstance: tableInstance,
            tableContainer: tableContainer,
            tableSettingsInstance: tableSettingsInstance,
            tableObjectType: tableObjectType,
            outstandingXHR: null,  // Handle to an in-flight XHR request to update the table
            hasPendingFetch: false,  // True if the user made a request to update the table while these was an outstanding XHR
        };
    }

    // These filters are in addition to the common filters activated in filter_bar.js
    function _initFilters(context) {
        // The tags filter currently relies on having a tableInstance
        tagFiltersComponent.initWithContext(context);
    }

    function _initActions(context) {
        bulkAddAsProspectsToComponent.initWithContext(context);
        bulkAssignToComponent.initWithContext(context);
        bulkCreatePortalUsersComponent.initWithContext(context);
        bulkDataRoomInviteComponent.initWithContext(context);
        bulkDownloadComponent.initWithContext(context);
        bulkEditComponent.initWithContext(context);
        bulkEmailComponent.initWithContext(context);
        bulkInvestorReportComponent.initWithContext(context);
        bulkPortalInviteComponent.initWithContext(context);
        bulkPublishComponent.initWithContext(context);
        bulkRequestDisregardedEntityDetailsComponent.initWithContext(context);
        bulkSendElectronicDeliveryConsentComponent.initWithContext(context);
        bulkSetInvestorGroupComponent.initWithContext(context);
        bulkSetPaymentPrefComponent.initWithContext(context);
        bulkSubscriptionInviteComponent.initWithContext(context);

        leadsActionComponent.initWithContext(context);
        var refreshTableOnSuccess = function(e, result) {
            _fetchTableData(context);
            $(document).off('jsq:modalSuccess', refreshTableOnSuccess)
        };

        leadsActionComponent.onModal(refreshTableOnSuccess);
    }

    function _registerTableSortEvents(context) {
        var targets = [
            '.table-scroller-fixed-column.sortable',
            'td.sortable'
        ];

        context.tableFilterBarData.tableContainer.on('click', targets.join(', '), function() {
            var column = $(this);

            context.setSortOrder([
                column.data('sort-key'),
                column.data('sort-dir')
            ]);

            context.markDirtyState();
        });
    }

    // NOTE: window.location.search implies dependence on storage/url_storage.js
    function _updateDownloadURL(context) {
        // Update download csv links on action menu (prospect and position lists)
        $('#menu-item-download-csv').attr('href', window.location.pathname + '/csv' + window.location.search);

        var comm_settings_url = window.location.pathname.replace('positions', 'comm_settings_csv')
        $('#menu-item-download-comm-settings-csv').attr('href', comm_settings_url + window.location.search);

        // Update download csv links in buttonbar (contacts and accounts)
        // TODO - remove this once account downloads are all celerized, in favor of the below
        $('.menu-item-download').each(function() {
            var link = $(this);

            var downloadPath = link.data('download-path');
            link.attr('href', window.location.pathname + '/' + downloadPath + window.location.search);

        });

        // Update csv modal download links
        $('.ajax-modal').each(function() {
            var link = $(this);
            if ($(this)[0].hasAttribute('download-path')) {
                var downloadPath = link.data('download-path');
                link.attr('data-url', downloadPath + window.location.search);
            }
        })
    }

    function _fetchTableData(context) {
        // Prevent running this function if the table that this context is registered for is no longer visible
        // Since tables can be hidden and not removed from the DOM, extra handlers will run if you navigate away
        // from table filter bar to another
        if (!$("#" + context.tableFilterBarData.tableId).is(":visible")) {
            return;
        }

        // No-op if the is an outstanding xhr request for the context
        if (context.tableFilterBarData.outstandingXHR !== null) {
            context.tableFilterBarData.hasPendingFetch = true;
            return;
        }

        var tableInstance = context.tableFilterBarData.tableInstance;
        var tableContainer = context.tableFilterBarData.tableContainer;

        var expandedIds = context.tableFilterBarData.expandedIds = [];
        var expandedRegions = context.tableFilterBarData.expandedRegions = [];

        tableContainer.find('tr.expando.expando-expanded').each(function() {
            var tr = $(this);
            var rowId = tr.data('id');
            var region = tr.data('region');

            if (rowId) {
                expandedIds.push(rowId);
            } else if (region) {
                expandedRegions.push(region);
            }
        });

        tableInstance.toggleLoadingOverlay(true);

        var qs = urlStorageComponent.getQSFromParams(context);
        if (qs == window.location.pathname) {
            qs += '?clear';
        }

        context.tableFilterBarData.outstandingXHR = ajax(qs, {
            onSuccess: function(result) {
                var newContent = $('<div>' + (result.body || '').trim() + '</div>');
                var replacement = newContent.find('#' + context.tableFilterBarData.tableId);
                if (replacement[0]) {
                    tableContainer.replaceWith(replacement);
                    tableContainer = context.tableFilterBarData.tableContainer = replacement;
                    tableContainer[0].innerHTML = replacement[0].innerHTML;
                } else {
                    tableContainer.html(newContent);
                }

                tableInstance.init(tableContainer);

                _registerTableSortEvents(context);
                _restoreExpandedRows(context);

                manageViewsComponent.setPersonalized(context);

                if (result.page_components) {
                    result.page_components.forEach(function(componentName) {
                        require(['components/' + componentName], function(component) {
                            component.init(tableContainer);
                        });
                    });
                }
                if(typeof window.__jsqRenderPillars__ === 'function') {
                    window.__jsqRenderPillars__();
                }
                setTimeout(function() {
                    _updateDownloadURL(context);

                    if (!context.hasAnyFilters()) {
                        filterBarComponent.resetToDefaultUI(context);
                    }
                }, 1);
            },
            onComplete: function(result) {
                tableInstance.toggleLoadingOverlay(false);
                context.tableFilterBarData.outstandingXHR = null;
                $(window).trigger("jsq:tableReload");
                // If there was a pending fetch request, dispatch it.
                _executePendingFetch(context);
            }
        }, 'json');
    }

    function _executePendingFetch(context) {
        // Check if a context has a pending data fetch request.  If it does, dispatch the fetch request.
        if (context.tableFilterBarData.hasPendingFetch === true) {
            context.tableFilterBarData.hasPendingFetch = false;
            _fetchTableData(context);
        }
    }

    function _restoreExpandedRows(context) {
        var tableContainer = context.tableFilterBarData.tableContainer;

        context.tableFilterBarData.expandedIds.forEach(function(id) {
            tableContainer.find('tr.expando.expando-collapsed[data-id="' + id + '"]')
                          .click();
        });

        context.tableFilterBarData.expandedRegions.forEach(function(region) {
            tableContainer.find('tr.subheading.expando.expando-collapsed[data-region="' + region + '"]')
                          .click();
        });

        var expandAllLink = $('.expand-all-regions > a');
        var allExpanded = !tableContainer.find('tr.subheading.expando.expando-collapsed')[0];

        // Set the expand-all link to 'collapse' if all regions are expanded
        if (allExpanded && expandAllLink[0]) {
            var newContent = expandAllLink.html().replace(/Expand/, 'Collapse');
            expandAllLink.data('expanded', true).html(newContent);
        }
    }

    function _handleClickedClearFilters(context, url) {
        // TODO: Need to scope these DOM queries.
        $('[data-visibility-group="show-filter-options"]').removeClass('hidden');
        $('[data-visibility-group="filter-options"]').addClass('hidden');
        $('[data-visibility-group="clear-filter"]').addClass('hidden');

        context.buttonbarNode.find('li input:checked').prop('checked', false);

        // If custom date range is set, clear and reset to default
        context.buttonbarNode.find('button[data-filter-name="period"]')
                                     .removeClass('hidden');
        context.buttonbarNode.find('form.custom_date_range')
                             .addClass('hidden');

        var i = url.indexOf('?');
        if (i > 0 && url.slice(i, i+6) != '?clear') {
            urlStorageComponent.populateParamsFromQS(context, url.substring(i+1));
        } else {
            context.clearFilters();
        }

        // If the user came to this page from a saved view,
        // the querystring will be blank even though
        // they may be seeing filtered data. In this
        // case newUrl will be no different than the current
        // page url; the browser will not bother triggering
        // a History 'statechange' event, so we arbitrarily
        // add '?clear' to newUrl to ensure that a new event is triggered.
        var newUrl = urlStorageComponent.getQSFromParams(context);
        if (newUrl == window.location.pathname) {
            newUrl += '?clear';
        }
        context.pushState({}, newUrl);
    }

    return tableFilterBarComponent;
});

